export default __webpack_public_path__ + "img/77c5e1bece14d62b10efddd8cc2e291a.png";